import ApiServer from "../ApiServer.js";
import * as amplify from "./amplify.ts";
import * as Html from "./Html.ts";
import $ from "../$.js";


var
  // Constants

  // CSS class applied to valid form controls
  VALID_CLASS = "fw-form-valid-control",

  // CSS class applied to invalid form controls
  INVALID_CLASS = "fw-form-invalid-control",

  // CSS selector for invalid form controls
  INVALID_SELECTOR = "."+INVALID_CLASS,

  // CSS selector for inputs
  INPUT_SELECTOR = ":input",

  // CSS selector for invalid inputs
  // (the first invalid input will be focused)
  INVALID_INPUT_SELECTOR = INVALID_SELECTOR + INPUT_SELECTOR,

  // data attribute set to false initially and to true after first submission
  // to prevent the display of errors before the whole form has been filled
  FORM_VALIDATION_ATTRIBUTE = "data-fw-form-validation",

  // value of the form validation attribute to enable validation
  FORM_VALIDATION_ACTIVE = "active";

/*
  Function: isEmpty(input)
  Check whether an input is empty

  Parameter:
    input - object, jQuery object wrapping an input element

  Returns:
    true if the input is empty,
    false otherwise
*/
function isEmpty(input){
  if(input.attr("type")==="file"){
    return input.get(0).files.length===0;
  }
  input.val(input.val().trim());
  return (
    input.val() === "" || (input.attr('type')==="checkbox" && !input.prop('checked'))
  );
}

function removeBeforeAlert (element) {
  element.next ('.fw-input-alert').remove ();
}

/*
  Function: markValid(element)
  Style an element as valid
  The valid class is set and the invalid class is removed.

  Parameter:
    element - object, jQuery object wrapping an element
    message - string, optional, message to display in element.
      For example, use "" to reset an error message to empty.
*/
function markValid(element){
  removeBeforeAlert (element);
  element.removeClass(INVALID_CLASS).addClass(VALID_CLASS);
  setTimeout(function(){
    element.removeClass(VALID_CLASS);
  },500)
  return element;
}

/*
  Function: markInvalid(element,message)
  Style an element as invalid
  The valid class is removed and the invalid class is set.

  Parameters:
    element - object, jQuery object wrapping an element
    message - string, optional, error message to display in element
*/
function markInvalid(element,message){
  removeBeforeAlert (element);
  element.removeClass(VALID_CLASS).addClass(INVALID_CLASS);
  if (message) {
    var alertNode =  $("<div class='fw-input-alert'><span>"+message+"</span></div>");
    alertNode.insertAfter(element);
    if(element.attr('type')!=='checkbox'){
      alertNode.css('bottom',(element.get(0).offsetParent.getClientRects()[0].bottom-element.get(0).getClientRects()[0].top+5)+'px')
      alertNode.css('right',(element.get(0).offsetParent.getClientRects()[0].right-element.get(0).getClientRects()[0].right)+'px')
    }
    setTimeout(function(){alertNode.css('transform','unset');},0)
    if(alertNode.parents('.V4').length){
      setTimeout(function(){alertNode.fadeOut(500)},2000)
    }
  }
  return element;
}
/*
  Function: checkFormControl(formControl,isValid,onValid,onInvalid)
  Base function for the validation of the form control

  This function is intended as a helper for the development of more specific
  methods for different types of form controls: input, select, password,
  email, date...

  Parameters:
    formControl - object, jQuery object wrapping a form control or
                  part of a widget used as a form control
    isValid - object, function(formControl): boolean, function used to
              check the validity of the form control; returns true when
              the form control is valid, false for invalid, any other other
              value skips the validation
    onValid - optional, function(formControl), callback triggered when the
              form control is valid, after marking it as valid using the
              function markValid(). This callback is useful to trigger the
              validation of other form controls related to this one.
    onInvalid - optional, function(formControl), callback triggered when the
                form control is invalid, after marking it as invalid using
                the function markInvalid(). This method is useful to display
                more than one form control as invalid after a single
                validation, or to display an error message associated
                with an invalid control.
*/
function checkInput(formControl,isValid,errorMessage){
  var 
    form = formControl.parents('form'),
    errorDisplayTarget = formControl;
  if(formControl.attr('type')==='hidden'){
    errorDisplayTarget = formControl.parent();
  }
  
  formControl.on("blur change show",function(){
    if (form.attr(FORM_VALIDATION_ATTRIBUTE) !== FORM_VALIDATION_ACTIVE) {
      // skip validation until first submission
      return;
    }
    try{
      switch(isValid(formControl)){
        case true:
          markValid(errorDisplayTarget);
          break;
        case false:
          markInvalid(errorDisplayTarget,errorMessage);
          break;
        default:
          // any other value skips the validation
      }
    }catch(e){
      markInvalid(errorDisplayTarget,e.message);
    }

  });
}

/*
  Function: isValid(form): boolean
  Check whether the whole form is valid

  Parameter:
    form - object, jQuery object wrapping a form element

  Returns:
    false if any element is found with the invalid class,
    true otherwise
*/
function isValid(form){
  return (
    form.has(INVALID_SELECTOR).length === 0
  );
}

function validate(form,then){
  form.attr(FORM_VALIDATION_ATTRIBUTE, FORM_VALIDATION_ACTIVE);
  try{
    // blur each control to trigger handler registered for validation
    form
      .find(INPUT_SELECTOR)
      //clean previous validation result
      .removeClass(INVALID_CLASS).removeClass(VALID_CLASS)
      .blur();
  }catch(e){
    console.log(e);
  }
  if ( !isValid(form) ){
    // focus first invalid input
    form.find(INVALID_INPUT_SELECTOR).first().focus();
    if(then){
      setTimeout(function(){
        if(isValid(form)){then()}
      },100) //FIXME should retry several times
    }
    return false;
  }else{
    if(then) then();
  }
  return true;
}
/*
  validate form before submit, if specific api form (always the case in ou site) we call it
  if amplify attribute use it as success idem for error
*/
$(document).on('submit','form',function(event){
  
  var form = $(this),api,apiName,onSuccess,onError;
  try{
    form.attr('data-submit-running','true');
    if(form.attr("data-fw-form-amplify")){
      onSuccess = function(data){
        amplify.publish(form.attr("data-fw-form-amplify"), data);
      };
    }
    if(!validate(form)){
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
    Html.runClick();
    apiName = form.attr("data-fw-dyn-action");
    if(apiName){
      event.preventDefault();
      api =  ApiServer[apiName];
      if(!api){
        throw new Error("no Api named "+apiName);
      }
      api(form.get(0),onSuccess,onError);
      return false;
    }else if(onSuccess){
      onSuccess();
      event.stopImmediatePropagation();
    }
    //return false;
  }finally{
    form.removeAttr(FORM_VALIDATION_ATTRIBUTE);
    form.removeAttr('data-submit-running');
  }
})

Html.register({
  formvalidate:function(){
    validate(this.parent('form'),()=>{
      var 
        chainedClick = arguments[0],
        chainedArguments = Array.prototype.splice.apply(arguments,[1]);
      Html.trigger(this,chainedClick,chainedArguments)
    })
  }
})

export {
  // Public API
  isEmpty,
  markValid,
  markInvalid,
  checkInput,
  validate
};


